import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";

import { MainRoutes } from "./routes";

import "./index.css";

const axiosClient = axios.create({
  baseURL: "https://api.fcaspays.com.au/" //"http://localhost:5000/"
  // headers: {'Authorization': 'Foo'}
});
// axiosClient.interceptors.response.use(function (response) {
// 	// Do something with response data
//   console.log('resp9onse interceptor', response);
// 	return response;
// }, function (error) {
// 	// Do something with response error
// 	return Promise.reject(error);
// });
window.axiosClient = axiosClient;

ReactDOM.render(<MainRoutes />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js